// Automatically configure Distance, Store limit, and check the Sephora filter
document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
        const checkbox = document.querySelector('.search_filter input[type="checkbox"]');
        const withinDistance = document.getElementById('within_distance');
        const limit = document.getElementById('limit');

        if (checkbox && withinDistance && limit) {

            // Set "No Limit"
            withinDistance.value = '0';
            withinDistance.dispatchEvent(new Event('change', { bubbles: true }));

            // Set result limit to 100
            limit.value = '100';
            limit.dispatchEvent(new Event('change', { bubbles: true }));

            // Apply filter
            if (!checkbox.checked) {
                checkbox.click();
            }
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});